import { useQuery } from '@tanstack/react-query'

import { buildAvailabilityQueryOptions } from '@/components/integration/nylas/scheduler/helpers'
import {
  AvailabilityFilter,
  EVERY_ADVISER_AVAILABILITY_FILTER,
  SchedulerAvailabilitySource,
  SchedulerOwningEntityType,
} from '@/components/integration/nylas/scheduler/types'

export default function useAvailabilityQuery(
  type: SchedulerOwningEntityType,
  owningEntityId: number | string,
  start: Date,
  end: Date,
  availabilityFilter: AvailabilityFilter = EVERY_ADVISER_AVAILABILITY_FILTER,
  options: {
    enabled?: boolean
    availabilitySource?: SchedulerAvailabilitySource
  } = {},
) {
  return useQuery({
    ...buildAvailabilityQueryOptions(
      type,
      owningEntityId,
      start,
      end,
      availabilityFilter,
      options.availabilitySource,
    ),
    enabled: options.enabled ?? true,
  })
}
